const STORAGE_KEY = 'fixflow_palette_recent';
const MAX_RECENT = 5;

export type PaletteRecentItem = {
  type: 'ticket' | 'customer' | 'inventory' | 'price' | 'action' | 'nav' | 'inquiry';
  id: string;
  label: string;
  sublabel?: string;
  link: string;
};

export function loadPaletteRecent(): PaletteRecentItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as PaletteRecentItem[];
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function pushPaletteRecent(item: PaletteRecentItem): void {
  const existing = loadPaletteRecent().filter((r) => !(r.type === item.type && r.id === item.id));
  const next = [item, ...existing].slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
